import type { Campaign } from '@/api/types/graphql';
import type {
  CampaignTemplatesQueryResponse,
  CampaignTemplatesQueryVariables,
} from '@/api/graphql/queries/campaignTemplates.generated';

import { useCampaignTemplatesQuery } from '@/api/graphql/queries/campaignTemplates.generated';
import { useCampaignStore } from '../stores/campaign';
import { mappingDataCampaign } from '../utils/campaign';
import { useStore } from 'vuex';

export const useQueryCampaignsByThemePageId = () => {
  const store = useStore();
  const campaignStore = useCampaignStore();
  const pageId = computed(() => store.state.app.pageInfo.page.g_id);
  const templateSuffix = computed(() => `gem-${pageId.value}-template`);
  const isFetchedCampaignThemePage = computed(() => campaignStore.getters.getIsFetchedCampaignThemePage);
  const variables = computed<CampaignTemplatesQueryVariables>(() => ({
    where: {
      hasVariantsWith: [
        {
          templateSuffixContains: templateSuffix.value,
        },
      ],
    },
  }));

  const handleOnSuccess = (data: CampaignTemplatesQueryResponse) => {
    campaignStore.commit('setIsFetchedCampaignThemePage', true);

    const campaignsEdges = data?.campaigns?.edges;
    const campaignNodes = campaignsEdges?.map((item) => item?.node) as Campaign[];
    const campaigns = mappingDataCampaign(campaignNodes);
    const campaign = campaigns.shift() as Campaign;
    campaignStore.commit('setCampaignThemePage', campaign);
  };

  useCampaignTemplatesQuery(variables, {
    cacheTime: 0,
    enabled: true,
    onSuccess: handleOnSuccess,
  });

  return { isFetchedCampaignThemePage };
};
